var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{attrs:{"id":"app"}},[_c('TheHeader'),_c('main',{staticClass:"app-main"},[_c('Features'),_c('Banner'),_c('InfoForm'),_c('Infos')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }